export default {
  singleOnly: 'SINGLE_ONLY',
  multiOnly: 'MULTI_ONLY',
  mixed: 'MIXED',
};
